module.exports = "/assets/data/a0d1eb38400c7b59ff618be5e0dbfa47-SE4.data.json";